module.exports = __webpack_public_path__ + "snd/9531b2caf5c618b7a1233354e857785b.wav";